<div class="delivery-countdown-timer-form-display-conditions">
  <div class="content">
    <div class="section">
      <pdq-heading element="h5">Display Conditions</pdq-heading>
      <div class="controls-wrapper">
        <span>This Extension Will Only Appear If:</span>
        <pdq-rules-dynamic-form
          [formGroup]="formGroup"
          formArrayFieldName="displayRules"
          [rules]="displayRules | addCurrencyOption: shopCurrencySymbol"
          [entities]="displayRulesEntities"
          [shopCurrencySymbol]="shopCurrencySymbol"
          [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
      </div>
    </div>
  </div>
</div>
